import FormSwitch from "../../components/FormSwitch";

type Props = {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
};

export default function CombinationSwitch({ enabled, setEnabled }: Props) {
  const title = `${
    enabled ? "Desactivar" : "Activar"
  } inventario para esta combinación`;

  const body = `Pulsa aquí para ${
    enabled ? "desactivar" : "activar"
  } el inventario para esta combinación.`;

  return (
    <FormSwitch
      title={title}
      body={body}
      value={enabled}
      onValueChange={setEnabled}
    />
  );
}
